export default __webpack_public_path__ + "static/media/avatar-2.d72d95a8.jpg";